// DS: i8.3
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const ModerationAlert: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8ZM7 9V4H9V9H7ZM7 13V11H9V13H7Z"
        />
      </svg>
    </IconWrap>
  );
};
ModerationAlert.displayName = 'ModerationAlert';

export default ModerationAlert;
